export default __webpack_public_path__ + "static/media/awards.8740e739.jpg";